<template>
  <el-dialog class="include-gis-dialog" :visible.sync="dialogForms" :close-on-press-escape="false"
    :close-on-click-modal="false" top="10vh" width="1185px" height="721px" title="站点信息" :destroy-on-close="true"
    @close="close()">
    <template slot="title">
      <div class="dialogTitles"><span></span> <b>已绑定监测点位</b></div>
    </template>
    <div class="tabs">
      <div class="operateBtn">
        <el-button type="primary" size="small" @click="add()">添加</el-button>
      </div>
      <el-table :data="tableData" border class="tableStyle" height="calc(100vh - 340px)">
        <el-table-column label="序号" type="index" width="52">
        </el-table-column>
        <el-table-column v-for="col in head" :key="col.prop" :prop="col.prop" :label="col.label" align="left"
          show-overflow-tooltip :sortable="col.sorts" :width="col.widths">
          <template v-if="col.isBar" #default="{ row }"> </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <span class="linkBtn" @click="unMonitor(row.id)">解绑</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import monitoringApi from '@/apis/siteAdministration/monitoringApi'
import equipmentManageApi from '@/apis/equipmentManage/equipmentManageApi'
import indexMixin from '@/mixins/index.js'
import { mapActions, mapState } from 'vuex'
export default {
  mixins: [indexMixin],
  data() {
    return {
      pageParams: {
        size: -1,
        current: 1
      },
      tableData: [],
      head: [
        { prop: 'pointName', label: '点位名称' },
        { prop: 'pointCode', label: '点位编号' },
        { prop: 'dataTypeName', label: '数据类型' },
        { prop: 'importantName', label: '重点检测' },
        { prop: 'supplyCalculateName', label: '参与供气量计算', widths: '120' },
        { prop: 'description', label: '监测位置描述', widths: '120' },
        { prop: 'collectPointName', label: '远传采集点', widths: '120' }
      ],
      total: 0,
      equipmentId: null,
      stationId: null,
      typeName: '',
      equipmentName: '',
      dialogForms: false,
      info: '弹框信息',
      stationTypeDict: []

    }
  },
  computed: {
    ...mapState('dict', ['monitorPointStatus'])
  },
  created() {
    console.log('created');
  },
  mounted() {
    
  },
  methods: {
    ...mapActions('dict', ['getDropdown', 'getDataType']),
    async open(equipmentId, stationId, equipmentName, typeName) {
      await this.getDropdown('monitorPointStatus,important')
      await this.getDataType()
      this.equipmentId = equipmentId
      this.stationId = stationId
      this.typeName = typeName
      this.equipmentName = equipmentName
      this.getList(this.pageParams)
      this.dialogForms = true
    },
    async getList(pageParams) {
      let { equipmentId } = this
      let params = JSON.parse(JSON.stringify(pageParams))
      params.eqId = equipmentId
      params.eqBindStatus = 1
      params.dataFlag = 'scada'
      monitoringApi.getList(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else this.$message.error(res.msg)
      })
    },
    add() {
      let { equipmentId, stationId, equipmentName } = this
      this.$parent.$refs.bind.open(equipmentId, stationId, equipmentName, this.typeName)
    },
    reset() {
      this.pageParams = {
        current: 1,
        size: -1
      }
      this.getList(this.pageParams)
    },
    /**
     * Description  解绑监测点位
     * @author slx
     * @date 2024-01-06
     * @param {any} id
     * @returns {any}
     */
    unMonitor(monitorPointIds) {
      this.$confirm('确认解绑该监测点位？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        equipmentManageApi.monitorPoint({monitorPointIds}).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getList(this.pageParams)
          } else this.$message.error(res.msg)
        })
      }).catch(action => {});
    },
    close() {
      Object.assign(this.$data, this.$options.data())
    },
  }
}
</script>

<style lang="scss" scoped>
.linkBtn {
    cursor: pointer;
    color: #1082FF;
}
.tabs {
  background: #fff;
  padding: 16px 20px 8px 20px;
  height: 660px;

  .topSearch {
    color: #0F0F0F;
    border-bottom: 1px solid #E3E3E3;
    padding: 0 10px 16px;

    .selectBox {
      width: 200px;
      margin: 0 30px 0 4px;
    }

    .searchBtn {
      display: inline-block;
    }
  }

  .operateBtn {
    margin: 0 0 10px;
  }
}</style>